// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobileTabPicker {
    width: 100%;
    margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/mobileTabPicker/MobileTabPicker.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".mobileTabPicker {\n    width: 100%;\n    margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
